import { connect } from 'react-redux';
import ViewDismantleMrf from "./View";
import { bindActionCreators } from 'redux';
import {getDismantleMrfBySiteId} from "../../../../services/redux/installation/siteListing/action";


const mapStateToProps = (state) => ({
    dismantleMrfViewResponse: state.siteListingReducer.dismantleMrfViewResponse,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            getDismantleMrfBySiteId
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(ViewDismantleMrf);
